import styled from "styled-components";

export const StyledMatchContainer = styled.div`
  .mls-c-match-list__match-watch {
    align-self: flex-start;
    justify-content: flex-end;
  }

  &.--mobile {
    margin-bottom: 12px;

    .mls-c-match-list__strip-time,
    .mls-c-match-list__match-watch {
      align-self: auto;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
    }
  }
`;

export const StyledExplainerBar = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 4px;
`;

export const StyledExplainerBarCompetition = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-bottom: 8px;
`;

export const StyledMatch = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  padding: 12px 0;

  div,
  a {
    z-index: 2;
  }

  .mls-c-match-tile {
    width: 420px;
    display: flex;
    justify-content: center;

    .mls-c-club {
      flex-shrink: 0;
    }

    .--home .mls-c-club__shortname {
      text-align: right;
    }

    .mls-c-club__shortname {
      width: 120px;
    }

    picture,
    picture img,
    .mls-c-club__picture {
      width: 28px;
      height: 28px;
      margin-top: 0;
    }
  }

  &:before {
    content: "";
    top: 0;
    position: absolute;
    box-shadow: 0;
    box-sizing: content-box;
    background: none;
    width: 100%;
    height: calc(100% + 2px);
    z-index: 1;
    transition: all 200ms;
  }

  &:hover:before,
  &:focus:before {
    content: "";
    top: 0;
    position: absolute;
    box-shadow: 0px 4px 20px 4px rgba(0, 0, 0, 0.08),
      0px 2px 10px 1px rgba(0, 0, 0, 0.1);
    box-sizing: content-box;
    padding: 0 10px;
    border-radius: 6px;
    margin: -1px -10px;
    background: ${(props) => props.theme.figma.base.color_white_100};
    width: 100%;
    height: calc(100% + 2px);
    z-index: 1;

    + div {
      border: none;
    }
  }


`;

export const StyledBroadcastersWrapper = styled.div`
  height: 15px;
  margin-top: 4px;
  align-self: flex-start;
`;
